module.exports = __webpack_public_path__ + "static/media/orange_page_btn_arrow.20fc27ef.svg";